import React from 'react';
import { Button } from '@mui/material';
import { useGridApiContext, gridVisibleColumnFieldsSelector, gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

interface CustomExportButtonProps {
  fileName: string;
  exportHeaders?: string[];
}

const CustomExportButton: React.FC<CustomExportButtonProps> = ({ fileName, exportHeaders }) => {
  const apiRef = useGridApiContext();

  const handleExport = () => {
    const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);

    // If exportHeaders is provided, use only those columns in that order
    const columnsToExport = exportHeaders
      ? exportHeaders
      : visibleColumnFields.filter(
        (field) => field !== '__check__' && field !== 'actions'
      );

    const data = filteredSortedRowIds.map((id) => {
      const row: Record<string, any> = {};
      columnsToExport.forEach((field) => {
        // When using exportHeaders, field is the exact header name we want
        if (exportHeaders) {
          const cellValue = apiRef.current.getCellParams(id, field).value;
          row[field] = cellValue;
        } else {
          const column = apiRef.current.getColumn(field);
          const cellValue = apiRef.current.getCellParams(id, field).value;
          row[column.headerName || field] = cellValue;
        }
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <Button startIcon={<FileDownloadIcon />} onClick={handleExport} size="small">
      Export to Excel
    </Button>
  );
};

export default CustomExportButton;
